import React from "react";
import BaseDefault from "../../core/BaseDefault";

export default function Blank_page(){
    return(
        <BaseDefault
            styles="title-page"
            title = "Blank"
        >
                
        </BaseDefault>
    )
}